import { FunLogger } from '@funkit/connect-core'

import { DatadogHttpLogTransport } from './datadogHttpLogTransport'

// Public Datadog client token (same one `@funkit/connect` uses for web). A
// client token is safe to embed in client apps.
const DDOG_CLIENT_TOKEN = 'pub4f86c6be8c792cb48dc156a8c17d9a47'

/**
 * The React Native `FunLogger` singleton. Mirrors `@funkit/connect`'s web
 * `logger`, but injects the raw-HTTP {@link DatadogHttpLogTransport} (no Datadog
 * SDK, no native modules) instead of `@datadog/browser-logs`. The host wires
 * `logger.configure(...)` / `setUserInfo(...)` once identity is available.
 */
export const logger = new FunLogger(
  new DatadogHttpLogTransport({
    clientToken: DDOG_CLIENT_TOKEN,
    // service defaults to 'connect-rn' (see DatadogHttpLogTransport).
  }),
)

// Names a developer's build in Datadog and switches on the MoonPay frame taps.
// Metro inlines `EXPO_PUBLIC_*` only outside `node_modules` (expo/expo#46982),
// so this resolves in this monorepo's playground and is `undefined` — taps off —
// for anyone consuming the published package. That is the intent: it is dev
// tooling, and a host needs no API to opt out of it.
logger.setDebugTag(process.env.EXPO_PUBLIC_DEV_TAG ?? null)
